import { Stethoscope } from "lucide-react";
import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  iconClassName?: string;
  textClassName?: string;
  showText?: boolean;
}

export function Logo({
  className,
  iconClassName,
  textClassName,
  showText = true,
}: LogoProps) {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <Stethoscope className={cn("w-8 h-8 text-primary", iconClassName)} />
      {showText && (
        <span
          className={cn(
            "font-headline font-bold text-foreground",
            textClassName,
          )}
        >
          RepasoGPC
        </span>
      )}
    </div>
  );
}
